import "../../styles/donnad/index.scss";
import {SmartComponentManager} from "smart-component-js";
import DefaultCtrl from "./controllers/DefaultCtrl";
import HeaderComponent from "./components/HeaderComponent";
import SearchRecipeComponent from "./components/SearchRecipeComponent";
import AdvancedSearchComponent from "./components/AdvancedSearchComponent";
import AdvancedSearchBarComponent from "./components/AdvancedSearchBarComponent";
import ShareComponent from "./components/ShareComponent";
import CarouselComponent from "./components/CarouselComponent";
import CarouselContentComponent from "./components/CarouselContentComponent";
import SearchComponent from "./components/SearchComponent";
import OverlayComponent from "./components/OverlayComponent";
import MenuAccordionComponent from "./components/MenuAccordionComponent";
import MenuComponent from "./components/MenuComponent";
import SingleCarouselLandingComponent from "./components/SingleCarouselLandingComponent";
import TripleCarouselLandingComponent from "./components/TripleCarouselLandingComponent";
import CalendarCarouselLandingComponent from "./components/CalendarCarouselLandingComponent";
import RecipeCarouselLandingComponent from "./components/RecipeCarouselLandingComponent";
import ArticleIndexComponent from "./components/ArticleIndexComponent";
import ArticleRecipeGalleryComponent from "./components/ArticleRecipeGalleryComponent";
import SearchResultsComponent from "./components/SearchResultsComponent";
import SurveyComponent from "./components/SurveyComponent";
import SurveyThankYouComponent from "./components/SurveyThankYouComponent";
import ScreensetComponent from "../common/ScreensetComponent";
import GenericSwiperComponent from "./components/GenericSwiperComponent";
import MissionEntrypointComponent from "./components/MissionEntrypointComponent";
import ArticleInfoComponent from "./components/ArticleInfoComponent";
import DownloadCouponComponent from "./components/DownloadCouponComponent";


SmartComponentManager.registerComponents({
    DefaultCtrl,
    HeaderComponent,
    SearchRecipeComponent,
    ScreensetComponent,
    AdvancedSearchComponent,
    AdvancedSearchBarComponent,
    CarouselComponent,
    CarouselContentComponent,
    ShareComponent,
    SearchComponent,
    OverlayComponent,
    MenuAccordionComponent,
    MenuComponent,
    SingleCarouselLandingComponent,
    TripleCarouselLandingComponent,
    CalendarCarouselLandingComponent,
    RecipeCarouselLandingComponent,
    ArticleIndexComponent,
    ArticleRecipeGalleryComponent,
    SearchResultsComponent,
    SurveyComponent,
    GenericSwiperComponent,
    SurveyThankYouComponent,
    MissionEntrypointComponent,
    ArticleInfoComponent,
    DownloadCouponComponent,
});

document.addEventListener("DOMContentLoaded", () => {
    let body = document.querySelector('body [component="DefaultCtrl"]');
    SmartComponentManager.initComponentByName(body, 'DefaultCtrl');
});
